var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Author',{attrs:{"author":_vm.author,"text":_vm.testPerformedByString}})}
var staticRenderFns = []

export { render, staticRenderFns }